import { FormControlLabel, Checkbox } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';

import { useDispatch } from 'react-redux';
import { Box } from 'components/ui';
import BillzTypography from 'components/BillzTypographies/BillzTypography';

import { usePutUpdateUserPreferences } from 'api/endpoints/putUpdateUserPreferences';
import { doGetAuthenticatedUserAsync } from 'features/logon/logonSlice';

import * as Styled from './SettingsPreferences.styles';

export const SettingsPreferences = ({ userPreferences, refetchUserData }) => {
    const dispatch = useDispatch();

    const { mutate: updateUserPreferences } = usePutUpdateUserPreferences({
        onSuccess: () => {
            dispatch(doGetAuthenticatedUserAsync());
            refetchUserData();
        }
    });

    const onShowSplitPaymentWarningChanged = (checked) => {
        updateUserPreferences({ ...userPreferences, doNotShowSetSplitPaymentWarningMessage: checked });
    };

    return(
        <Styled.Wrapper>
            <Box title="Preferencje użytkownika">        
                <FormGroup sx={{mt:1}}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            id="split-payment--warning-checkbox"
                            size="small"
                            onChange={(e) => onShowSplitPaymentWarningChanged(e.target.checked)}
                            checked={userPreferences?.doNotShowSetSplitPaymentWarningMessage}                              
                        />
                        }
                        label={<BillzTypography>Nie pytaj o mechanizm podzielonej płatności podczas zapisywania dokumentu</BillzTypography>}
                        sx={{}}
                    />
                </FormGroup>
            </Box>
        </Styled.Wrapper>                
    );
}